const millisecondsPerSecond = 1000;

export const getDurationInSeconds = (startTime: number) => Math.floor((Date.now() - startTime) / millisecondsPerSecond);
